import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import { Divider } from '@material-ui/core';
import Moment from 'moment';

const useStyles = makeStyles((theme) => ({
  vendorCard: {
    width: '100%',
    height: '200px',
    display: 'flex',
    padding: '0.5rem',
    alignItems: 'center',
    justifyContent: 'space-around',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: 'rgba(188, 188, 188, 0.5) 0px 2px 9px 0px',
      borderRadius: '16px'
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem'
    }
  },
  vendorDetails: {
    display: 'flex',
    cursor: 'pointer',
    flexDirection: 'column',
    justifyContent: 'space-around',
    height: '70px'
  },
  vendorName: {
    fontSize: '20px',
    fontWeight: 700
  },
  distance: {
    color: '#727272',
    paddingRight: '5px'
  },
  root: {
    cursor: 'pointer',
    borderRadius: '25px',
    height: 'fit-content',
    margin: '3%',
    marginBottom: '5%',
    '&:hover': {
      boxShadow: '0 3px 5px 2px rgba(0,0,0, .4)'
    },
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0), 0px 1px 1px 0px rgba(0,0,0,0), 0px 1px 3px 0px rgba(0,0,0,0)'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%'
  },
  content: {
    flex: '1 0 auto',
    textAlign: 'left'
  },
  cover: {
    width: '100%',
    height: '190px',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      height: '150px'
    }
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  gap: {
    margin: '4px 0px 2px'
  }
}));

const LiquorCard = ({
  icon,
  name,
  distance,
  days,
  city,
  closetime,
  opentime,
  latitude1,
  longitude1,
  street,
  id,
  superCategoryId,
  shopOpen,
  ...rest
}) => {
  const [deliveryTime, updateDeliveryTime] = useState('0 ');
  const classes = useStyles();
  const redirectToVendor = () => {
    const { superCategoryId } = rest.match.params;
    rest.history.push({
      pathname: `/super-category/${superCategoryId}/vendor/${id}`,
      state: {
        isRestaurant: rest?.location?.state?.isRestaurant
      }
    });
  };

  const lat = localStorage.getItem('latitude');
  const lng = localStorage.getItem('longitude');

  const getDistance = (la1, lon1, la2, lon2) => {
    const google = window.google;

    const origin1 = { lat: parseFloat(la1), lng: parseFloat(lon1) };
    const destinationB = { lat: parseFloat(la2), lng: parseFloat(lon2) };

    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin1],
        destinations: [destinationB],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.METRIC,
        avoidHighways: false,
        avoidTolls: false
      },
      (response, status) => {
        if (status !== 'OK') {
          alert('Error was: ' + status);
        } else {
          updateDeliveryTime(
            parseInt(response.rows[0].elements[0].duration.text) + 15
          );
        }
      }
    );
  };
  // getDistance(lat, lng, latitude1, longitude1);

  return (
    <Card className={classes.root} onClick={redirectToVendor}>
      <CardMedia
        component="img"
        className={classes.cover}
        image={
          icon 
        }
        title="vendor"
      />
      <div>
        <CardContent
          className={classes.content}
          style={{ paddingBottom: '2px', paddingTop: '0' }}
        >
          <b
            style={{
              marginLeft: '-5px',
              fontWeight: 700,
              textTransform: 'capitalize'
            }}
          >
            {name}
          </b>
          <div className="container mb-1">
            <div className="row">
              <div
                className="col-6"
                style={{ textAlign: 'initial', paddingRight: '5px' }}
              >
                <small
                  style={{
                    marginLeft: '-19px',
                    paddingLeft: '0px',
                    fontWeight: 600,
                    color: '#000'
                  }}
                  className={classes.gap}
                >
                  {street}
                </small>
              </div>
              <div
                className="col-6"
                style={{
                  textAlign: 'right',
                  padding: '0',
                  fontWeight: 600,
                  color: '#000'
                }}
              >
                <small color="textSecondary">
                  {(distance / 1000).toFixed(2)}KM
                </small>
              </div>
            </div>
          </div>
          <Divider />
          <div className="container mb-1">
            <div className="row">
              <div
                className="col-6"
                style={{ textAlign: 'initial', paddingRight: '5px' }}
              >
                <small
                  color="textSecondary"
                  style={{ marginLeft: '-19px', paddingLeft: '0px' }}
                  className={classes.gap}
                >
                  <i
                    className="fa fa-clock-o"
                    style={{ color: '#00000080' }}
                  ></i>{' '}
                  {rest?.duration?.text}
                </small>
              </div>
              <div
                className="col-6"
                style={{ textAlign: 'right', padding: '0' }}
              >
                <small
                  color="textSecondary"
                  style={{ color: shopOpen ? '#03913F' : 'red', fontWeight: 700 }}
                >
                  {shopOpen ? 'Open' : 'Closed'}
                </small>
              </div>
            </div>
          </div>
        </CardContent>
      </div>
    </Card>
  );
};

export default withRouter(LiquorCard);
